import { useState } from "react";
import { toast } from "sonner";
import { Input, Label } from "@bookdental/ui";
import { trpc } from "@/lib/trpc";
import { formatCnpj } from "@/lib/cnpj";
import { formatPhone } from "@/components/partners/partner-meta";
import { BlocoDeDados, BotaoSalvar } from "./BlocoDeDados";

/** CNPJ e telefone da organização. Cada bloco da seção Dados salva o próprio pedaço. */
export function CartaoDeContato({ canManage }: { canManage: boolean }) {
  const utils = trpc.useUtils();
  const perfil = trpc.organization.getProfiles.useQuery().data;
  const [contato, setContato] = useState<{ cnpj: string; phone: string } | null>(null);

  // Sincroniza do servidor até a pessoa mexer.
  const cnpj = contato?.cnpj ?? perfil?.document ?? "";
  const phone = contato?.phone ?? perfil?.phone ?? "";

  const salvar = trpc.organization.updateContact.useMutation({
    onSuccess: () => {
      toast.success("Dados cadastrais atualizados.");
      setContato(null);
      utils.organization.getProfiles.invalidate();
      utils.me.current.invalidate();
    },
    onError: (e) => toast.error(e.message || "Erro ao salvar os dados."),
  });

  return (
    <BlocoDeDados titulo="Dados cadastrais" descricao="CNPJ e telefone oficiais da organização — o que aparece em documentos e contatos.">
      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        <div className="space-y-1.5">
          <Label htmlFor="org-cnpj">CNPJ</Label>
          <Input
            id="org-cnpj"
            placeholder="00.000.000/0000-00"
            inputMode="numeric"
            value={formatCnpj(cnpj)}
            disabled={!canManage}
            onChange={(e) => setContato({ phone, cnpj: e.target.value.replace(/\D/g, "").slice(0, 14) })}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="org-phone">Telefone</Label>
          <Input
            id="org-phone"
            placeholder="(11) 3456-7890"
            inputMode="tel"
            value={formatPhone(phone)}
            disabled={!canManage}
            onChange={(e) => setContato({ cnpj, phone: e.target.value.replace(/\D/g, "").slice(0, 11) })}
          />
        </div>
      </div>
      {canManage && (
        <BotaoSalvar
          onClick={() => salvar.mutate({ document: cnpj || undefined, phone: phone || undefined })}
          disabled={salvar.isPending || contato === null}
          salvando={salvar.isPending}
        />
      )}
    </BlocoDeDados>
  );
}
